import { reportTypeOptionMapper, } from '@/types/entity/IHubAdjustmentDaily';
import { numberToFormatted, validateCountWithHypen, validateTextWithHypen, } from '@/utils';
import { getFormattedDate } from '@/utils/time';
import { brgChipColorMapper, } from '@/components/Common/Chip.vue';
import { getGlobalStore } from '@/lib/global-store';
import { i18n } from '@/locales';
const storeTypeChipConfigMapper = {
    B2B: {
        text: i18n.t('views.hub_adjustment.B2B'),
        color: brgChipColorMapper.blue,
    },
    GENERAL: {
        text: i18n.t('views.hub_adjustment.GENERAL'),
        color: brgChipColorMapper.green,
    },
    PURCHASE_GENERAL: {
        text: i18n.t('views.hub_adjustment.GENERAL'),
        color: 'blueGrey',
    },
};
export default class HubAdjustmentDailyReportItem {
    _item;
    _type;
    constructor(item) {
        this._item = item;
        const vuexStore = getGlobalStore();
        this._type = vuexStore.state.hubAdjustment.hubDailyReport.reportType;
    }
    // 구분 - storeType은 chip으로 적용
    get formattedStoreType() {
        if ('storeType' in this._item) {
            // 매입 허브 수수료의 경우 회색 칩 적용(figma)
            if (this._type === reportTypeOptionMapper.PURCHASE_HUB_FEE) {
                return storeTypeChipConfigMapper.PURCHASE_GENERAL;
            }
            return storeTypeChipConfigMapper[this._item.storeType];
        }
        return null;
    }
    // 본사계약 (src) - isAdjustmentByHeadOffice은 img로 적용
    get formattedIsAdjustmentByHeadOffice() {
        if ('isAdjustmentByHeadOffice' in this._item) {
            const state = this._item.isAdjustmentByHeadOffice ? 'ok' : 'leave';
            const fileName = `/svg/use-yn-${state}.svg`;
            return fileName;
        }
        return null;
    }
    // 정산일 (MM-dd)
    get formattedDate() {
        if ('date' in this._item) {
            return getFormattedDate(this._item.date, 'yyyyMMdd', 'MM-dd');
        }
        return null;
    }
    // 접수일 (MM-dd)
    get formattedOrderDate() {
        if ('orderDate' in this._item) {
            return getFormattedDate(this._item.orderDate, 'yyyyMMdd', 'MM-dd');
        }
        return null;
    }
    // 출금일 (MM-dd)
    get formattedTransactionDate() {
        if ('transactionDate' in this._item) {
            return getFormattedDate(this._item.transactionDate, 'yyyyMMdd', 'MM-dd');
        }
        return null;
    }
    // 주문 건수
    get formattedOrderCompletedCount() {
        if ('orderCompletedCount' in this._item) {
            return validateCountWithHypen(numberToFormatted(this._item.orderCompletedCount));
        }
        return null;
    }
    // 발생 건수
    get formattedStoreManagementDepositWithdrawalCount() {
        if ('storeManagementDepositWithdrawalCount' in this._item) {
            return validateCountWithHypen(numberToFormatted(this._item.storeManagementDepositWithdrawalCount));
        }
        return null;
    }
    // 수익
    get formattedRevenueCharge() {
        if ('revenueCharge' in this._item) {
            return numberToFormatted(this._item.revenueCharge, {
                style: 'currency',
            });
        }
        return null;
    }
    // 차감액
    get formattedDeductionCharge() {
        if ('deductionCharge' in this._item) {
            return numberToFormatted(this._item.deductionCharge, {
                style: 'currency',
            });
        }
        return null;
    }
    // 관리비(수익)
    get formattedSalesManagementFee() {
        if ('salesManagementFee' in this._item) {
            return numberToFormatted(this._item.salesManagementFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 관리비(차감)
    get formattedPurchaseManagementFee() {
        if ('purchaseManagementFee' in this._item) {
            return numberToFormatted(this._item.purchaseManagementFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 발주 허브명
    get formattedOrderHubName() {
        if ('orderHubName' in this._item) {
            return validateTextWithHypen(this._item.orderHubName);
        }
        return null;
    }
    // 수행 상점명
    get formattedStoreName() {
        if ('storeName' in this._item) {
            return validateTextWithHypen(this._item.storeName);
        }
        return null;
    }
    // 수행 허브명
    get formattedAgencyHubName() {
        if ('agencyHubName' in this._item) {
            return validateTextWithHypen(this._item.agencyHubName);
        }
        return null;
    }
    // 라이더 배달대행료
    get formattedWorkerDeliveryCharge() {
        if ('workerDeliveryCharge' in this._item) {
            return numberToFormatted(this._item.workerDeliveryCharge, {
                style: 'currency',
            });
        }
        return null;
    }
    // 라이더 수수료
    get formattedWorkerFee() {
        if ('workerFee' in this._item) {
            return numberToFormatted(this._item.workerFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 선차감
    get formattedPreDeductCharge() {
        if ('preDeductCharge' in this._item) {
            return numberToFormatted(this._item.preDeductCharge, {
                style: 'currency',
            });
        }
        return null;
    }
    // 정산 수수료
    get formattedHubAdjustmentFee() {
        if ('hubAdjustmentFee' in this._item) {
            return numberToFormatted(this._item.hubAdjustmentFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 공급가액 - 상점 수수료
    get formattedDeliveryCharge() {
        if ('deliveryCharge' in this._item) {
            return numberToFormatted(this._item.deliveryCharge, {
                style: 'currency',
            });
        }
        return null;
    }
    // 부가세 - 상점 수수료
    get formattedDeliveryChargeTax() {
        if ('deliveryChargeTax' in this._item) {
            return numberToFormatted(this._item.deliveryChargeTax, {
                style: 'currency',
            });
        }
        return null;
    }
    // 합계 - 상점 수수료
    get formattedDeliveryTotalCharge() {
        if ('deliveryTotalCharge' in this._item) {
            return numberToFormatted(this._item.deliveryTotalCharge, {
                style: 'currency',
            });
        }
        return null;
    }
    // 공급가액 - 상점
    get formattedStoreFee() {
        if ('storeFee' in this._item) {
            return numberToFormatted(this._item.storeFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 부가세 - 상점
    get formattedStoreFeeTax() {
        if ('storeFeeTax' in this._item) {
            return numberToFormatted(this._item.storeFeeTax, {
                style: 'currency',
            });
        }
        return null;
    }
    // 합계 - 상점
    get formattedStoreTotalFee() {
        if ('storeTotalFee' in this._item) {
            return numberToFormatted(this._item.storeTotalFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 공급가액 - 상점 관리비
    get formattedStoreManagementFee() {
        if ('storeManagementFee' in this._item) {
            return numberToFormatted(this._item.storeManagementFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 부가세 - 상점 관리비
    get formattedStoreManagementFeeTax() {
        if ('storeManagementFeeTax' in this._item) {
            return numberToFormatted(this._item.storeManagementFeeTax, {
                style: 'currency',
            });
        }
        return null;
    }
    // 합계 - 상점 관리비
    get formattedStoreManagementTotalFee() {
        if ('storeManagementTotalFee' in this._item) {
            return numberToFormatted(this._item.storeManagementTotalFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 공급가액 - 허브
    get formattedHubFee() {
        if ('hubFee' in this._item) {
            return numberToFormatted(this._item.hubFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 부가세 - 허브
    get formattedHubFeeTax() {
        if ('hubFeeTax' in this._item) {
            return numberToFormatted(this._item.hubFeeTax, {
                style: 'currency',
            });
        }
        return null;
    }
    // 합계 - 허브
    get formattedHubTotalFee() {
        if ('hubTotalFee' in this._item) {
            return numberToFormatted(this._item.hubTotalFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 발주총판수익 공급가액 - 허브
    get formattedDistributorHubFee() {
        if ('distributorHubFee' in this._item) {
            return numberToFormatted(this._item.distributorHubFee, {
                style: 'currency',
            });
        }
        return null;
    }
    // 발주총판수익 부가세 - 허브
    get formattedDistributorHubFeeTax() {
        if ('distributorHubFeeTax' in this._item) {
            return numberToFormatted(this._item.distributorHubFeeTax, {
                style: 'currency',
            });
        }
        return null;
    }
    // 발주총판수익 합계 - 허브
    get formattedDistributorHubTotalFee() {
        if ('distributorHubTotalFee' in this._item) {
            return numberToFormatted(this._item.distributorHubTotalFee, {
                style: 'currency',
            });
        }
        return null;
    }
}
